var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',_vm._b({directives:[{name:"tippy",rawName:"v-tippy"}],staticClass:"table_row",class:{
    'table_row--active': _vm.active,
    'table_row--bordered': _vm.bordered && !_vm.isLast,
    'table_row--light-error': _vm.errorLight,
    'table_row--dark-error': _vm.errorDark,
  },attrs:{"title":_vm.tooltip},on:{"show":function () { return !!_vm.tooltip; }}},'tr',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }